import React from 'react';
import {
  Icon,
  StickVideo,
  StickVideoBody,
  StickVideoHead,
  StickVideoIcons
} from '@components';
import { useMatchMedia } from '@utils';
import { breakpoints } from '@config';
import poster from './poster.webp';
import videoWebm from './video.webm';
import videoMpeg from './video.mp4';

const Technologies: React.FC = () => {
  const match = useMatchMedia(breakpoints.pc);
  
  return (
    <StickVideo
      id={'technologies'}
      position={'right'}
      poster={poster}
      webm={videoWebm}
      mpeg={videoMpeg}
      shadow={`linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 9.82%, rgba(0, 0, 0, 0) 93.29%, #000000 100%),
                 linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0) 16.29%, rgba(0, 0, 0, 0) 91.69%, #000000 100%)`}
    >
      {
        match
        && <StickVideoIcons>
          <Icon glyph={'app-5'} size={80} />
        </StickVideoIcons>
      }
      <StickVideoHead>
        Синтезируйте<br />
        аватаров с вашими<br />
        бизнес-механиками
      </StickVideoHead>
      <StickVideoBody>
        Например, в Звуке аватары играют на гитарах. Например, в Звуке аватары играют на гитарах
      </StickVideoBody>
    </StickVideo>
  );
};

export { Technologies };
